import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=f1b3971a&scoped=true&"
import script from "./ClassRoom.vue?vue&type=script&lang=js&"
export * from "./ClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoom.vue?vue&type=style&index=0&id=f1b3971a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b3971a",
  null
  
)

component.options.__file = "ClassRoom.vue"
export default component.exports